import { render, staticRenderFns } from "./gInfo.vue?vue&type=template&id=f3df227c&scoped=true&"
import script from "./gInfo.vue?vue&type=script&lang=js&"
export * from "./gInfo.vue?vue&type=script&lang=js&"
import style0 from "./gInfo.vue?vue&type=style&index=0&id=f3df227c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3df227c",
  null
  
)

export default component.exports